import UserRole from '../../../../shared/AuthRoles';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    Stack,
    Typography,
} from '@mui/material';
import React from 'react';
import {
    ChannelFilters,
    ChannelOptions,
    ChannelSort,
    StreamChat,
} from 'stream-chat';
import { ChannelList, Chat } from 'stream-chat-react';
import { ChannelListItem } from '../../Messages/Sidebar/MessagingSidebar';
import { useNavigate } from 'react-router-dom';
import { NavigateNext } from '@mui/icons-material';

const MessagingCard = () => {
    const loggedInUser = UserRole();
    const navigate = useNavigate();

    const client = StreamChat.getInstance(
        process.env.REACT_APP_STREAM_API_KEY as string,
    );

    const filters: ChannelFilters = {
        type: 'messaging',
        members: { $in: [loggedInUser.sub.toString()] },
    };
    const options: ChannelOptions = { state: true, presence: true, limit: 10 };
    const sort: ChannelSort = { last_message_at: -1 };

    return (
        <Stack sx={{ gap: 1, height: '100%' }}>
            <Typography variant='subHeading' sx={{ lineHeight: 2 }}>
                Messaging
            </Typography>
            <Card
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <CardContent>
                    <Chat client={client}>
                        <ChannelList
                            filters={filters}
                            options={options}
                            sort={sort}
                            Paginator={(props: any) => <>{props.children}</>}
                            Preview={(props) => <ChannelListItem {...props} />}
                        />
                    </Chat>
                </CardContent>
                <CardActions sx={{ mt: 'auto' }}>
                    <Button
                        onClick={() => navigate('/messages')}
                        endIcon={<NavigateNext />}
                        sx={{ ml: 'auto' }}
                    >
                        See all Messages
                    </Button>
                </CardActions>
            </Card>
        </Stack>
    );
};

export default MessagingCard;
